import {
  POST_YADS_INGESTION_REQUEST,
  POST_YADS_INGESTION_SUCCESS,
  POST_YADS_INGESTION_FAILURE,
  POST_YADS_INGESTION_RESET
} from '../../../Constants/actionTypes';

import { postYadsDemoIngestion } from '../../../Constants/apiService';

export const postYadsIngestionRequest = () => ({ type: POST_YADS_INGESTION_REQUEST });
export const postYadsIngestionSuccess = (data) => ({ type: POST_YADS_INGESTION_SUCCESS, payload: data });
export const postYadsIngestionFailure = (error) => ({ type: POST_YADS_INGESTION_FAILURE, payload: error });
export const postYadsIngestionReset = () => ({ type: POST_YADS_INGESTION_RESET });

export const startYadsIngestion = (payload) => {
  return async (dispatch, getState) => {
    dispatch(postYadsIngestionRequest());

    const accessToken = getState().auth.accessToken;

    try {
      const response = await postYadsDemoIngestion(payload, accessToken);
      dispatch(postYadsIngestionSuccess(response));
    } catch (error) {
      const errorMsg = error.message?.includes("fetch")
        ? "Unable to start ingestion. Please try again."
        : error.message;
      dispatch(postYadsIngestionFailure(errorMsg));
    }
  };
};